// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1857":"fc270446","9616":"d58239ee"}[chunkId] + ".chunk.css";
};